// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"1be0d823","145":"30e25488","381":"2d559349","573":"60388391","758":"cd372707"}[chunkId] + ".chunk.css";
};